
import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60)

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          return initialMinutes * 60 // Reinicia el contador
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [initialMinutes])

  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  }
}
